var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6606 6.2493C20.0752 6.61415 20.1156 7.24603 19.7507 7.66064L10.9507 17.6606C10.7609 17.8764 10.4874 18 10.2 18C9.91264 18 9.63915 17.8764 9.4493 17.6606L4.2493 11.7515C3.88444 11.3369 3.92478 10.7051 4.33938 10.3402C4.75399 9.97535 5.38587 10.0157 5.75073 10.4303L10.2 15.4863L18.2493 6.33938C18.6142 5.92478 19.246 5.88444 19.6606 6.2493Z",
    fill: "black"
  })));
};
export { SvgCheckMark as ReactComponent };
export default __webpack_public_path__ + "static/media/check-mark.46a33f4f.svg";